// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }


// 获取学段
export function getStage(params) {
  return request({
    url: "/api/config/get_stage",
    method: "get",
    params,
  });
}


// 获取班级
export function getClasses(params) {
  return request({
    url: "/api/config/get_classes",
    method: "get",
    params,
  });
}



// 获取学科
export function getSubject(params) {
  return request({
    url: "/api/config/get_subject",
    method: "get",
    params,
  });
}





// 学校类型管理
export function getSchoolType(params) {
  return request({
    url: "/api/config/get_school_type",
    method: "get",
    params,
  });
}



// 流程类型管理
export function getFlowType(params) {
  return request({
    url: "/api/config/get_flow_type",
    method: "get",
    params,
  });
}





// 活动主题列表
export function activityTheme(data) {
  return request({
    url: "/api/article/activity_theme",
    method: "post",
    data,
  });
}


// 授权网店搜索条件列表
export function getSearchList(params) {
  return request({
    url: "/api/sale_auth/search_list",
    method: "get",
    params,
  });
}

// 省份类型管理
export function getProvinceType(params) {
  return request({
    url: "/api/article/address",
    method: "get",
    params,
  });
}


// 获取条件列表（精品淘题）
export function examPropertyList(params) {
  return request({
    url: "/api/exam/property_list",
    method: "get",
    params,
  });
}


// 图书列表的搜索条件
export function bookScreeningCondition(params) {
  return request({
    url: "/api/book/screening_condition",
    method: "get",
    params,
  });
}



